import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { usePermissions } from '@/contexts/PermissionsContext';
import { LiveSearchDropdown } from '@/pages/Teaching/components/LiveSearchDropdown';

/** Globale Suche per Strg+S / Cmd+S — von jeder Verwaltungsseite aus. */
export const GlobalSearch = () => {
  const navigate = useNavigate();
  const { loaded, can } = usePermissions();
  const [open, setOpen] = useState(false);
  const [term, setTerm] = useState('');
  const allowed = loaded && can('enrollments', 'read');

  useEffect(() => {
    if (!allowed) return undefined;
    const onKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && !e.altKey && (e.key === 's' || e.key === 'S')) {
        e.preventDefault();
        setOpen(true);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [allowed]);

  const go = (params) => {
    setOpen(false);
    setTerm('');
    navigate(`/unterrichtsverwaltung?${params}`);
  };

  if (!allowed) return null;

  return (
    <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (!v) setTerm(''); }}>
      <DialogContent className="p-0 gap-0 max-w-lg top-[20%] translate-y-0 overflow-hidden" data-testid="global-search-dialog">
        <DialogTitle className="sr-only">Globale Suche</DialogTitle>
        <div className="relative">
          <Search className="absolute left-3 top-[22px] -translate-y-1/2 w-4 h-4 text-slate-400" />
          <input
            autoFocus
            type="text"
            value={term}
            onChange={(e) => setTerm(e.target.value)}
            placeholder="Alles durchsuchen: Schüler, Zahlungspflichtige, Lehrkräfte, Veranstaltungen..."
            className="w-full pl-9 pr-3 py-3 text-sm border-b border-slate-200 focus:outline-none"
            data-testid="global-search-dialog-input"
          />
          <LiveSearchDropdown
            inline
            searchTerm={term}
            onSelect={(s) => go(`student_id=${s.id}`)}
            onSelectCourse={(c) => go(`course_id=${c.id}`)}
            onSelectTeacher={(t) => go(`teacher_id=${t.id}`)}
            onSelectGuardian={(g) => go(`guardian_id=${g.id}`)}
            isOpen
            onClose={() => {}}
          />
        </div>
        <div className="px-3 py-1.5 text-[10px] text-slate-400 border-t border-slate-100 bg-slate-50">
          Strg+S / ⌘+S öffnet die Suche · Esc schließt
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GlobalSearch;
